import React from 'react';
import { View, Pressable } from 'react-native-web';
import CustomText from '../../components/atoms/CustomText';
import { colors, spacing } from '../../utils/styling';
import { useResponsive } from '../../hooks/useResponsive';

interface PaymentOverlayProps {
  isVisible: boolean;
  paymentStatus: any;
  paymentLoading: boolean;
  paymentError: string | null;
  paymentUrl: string | null;
  onOpenPayment: () => void;
  onCancelPayment: () => void;
}

const PaymentOverlay: React.FC<PaymentOverlayProps> = ({ 
  isVisible, 
  paymentStatus, 
  paymentLoading, 
  paymentError, 
  paymentUrl, 
  onOpenPayment, 
  onCancelPayment 
}) => {
  const { isMobile } = useResponsive();

  if (!isVisible) return null;

  return (
    <View style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      backgroundColor: 'rgba(0, 0, 0, 0.7)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
    }}>
      <View style={{
        backgroundColor: colors.white,
        borderRadius: 16,
        padding: isMobile ? spacing.lg : spacing.xxl,
        maxWidth: 500,
        width: '90%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: spacing.lg,
      }}>
        <CustomText style={{
          fontSize: isMobile ? 24 : 32,
          fontWeight: '600',
          color: colors.dark,
          fontFamily: "Nunito",
          textAlign: 'center',
          marginBottom: spacing.md,
        }}>
          Payment in Progress
        </CustomText>

        <CustomText style={{
          fontSize: isMobile ? 16 : 20,
          color: colors.gray[700],
          fontFamily: "Nunito",
          textAlign: 'center',
          marginBottom: spacing.lg,
        }}>
          {paymentLoading ? 'Checking payment status...' : 
           paymentStatus?.status === 'processing' ? 'Payment is being processed...' :
           'Please complete your payment in the other tab.'}
        </CustomText>

        {paymentError && (
          <CustomText style={{
            fontSize: isMobile ? 14 : 16,
            color: colors.danger,
            fontFamily: "Nunito",
            textAlign: 'center',
            marginBottom: spacing.md,
          }}>
            Error: {paymentError}
          </CustomText>
        )}

        <View style={{
          display: 'flex',
          flexDirection: 'column',
          gap: spacing.md,
          width: '100%',
        }}>
          {paymentUrl && (
            <Pressable 
              onPress={onOpenPayment}
              style={({ hovered }: { hovered: boolean }) => ({
                backgroundColor: hovered ? '#515A64' : colors.dark,
                paddingVertical: isMobile ? spacing.sm : spacing.md,
                paddingHorizontal: isMobile ? spacing.xl : spacing.xxl,
                borderRadius: 12,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
              })}
            >
              <CustomText style={{
                color: colors.white,
                fontSize: isMobile ? 16 : 18,
                fontWeight: '600',
                fontFamily: "Nunito",
              }}>
                Open Payment Page
              </CustomText>
            </Pressable>
          )}
          
          <Pressable 
            onPress={onCancelPayment}
            style={({ hovered }: { hovered: boolean }) => ({
              backgroundColor: hovered ? colors.gray[300] : colors.gray[200],
              paddingVertical: isMobile ? spacing.sm : spacing.md,
              paddingHorizontal: isMobile ? spacing.xl : spacing.xxl,
              borderRadius: 12,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
            })}
          >
            <CustomText style={{
              color: colors.danger,
              fontSize: isMobile ? 16 : 18,
              fontWeight: '600',
              fontFamily: "Nunito",
            }}>
              Cancel Payment
            </CustomText>
          </Pressable>
        </View>
      </View>
    </View>
  );
};

export default PaymentOverlay;